import { createAction, props } from "@ngrx/store";
import {
  IClientInfo, IGenerateOTPRequestBody, IGenerateOTPResponse, ILoginSuccessInfo,
  ITempTokenRequestBody, ITempTokenResponse,
  IVerifyOTPRequestBody, IVerifyOTPResponse,
  IVerifyRecaptchaRequest,
  IVerifyRecaptchaResponse
} from "../../models/authentication";
import { IErrors } from "../../models/error";
import { IResponse } from "../../models/admin";

enum AuthActions {
  // Fetch Client Info
  FetchClientInfo = '[Auth] Fetch Client Info',
  FetchClientInfoSuccess = '[Auth] Fetch Client Info Success',
  FetchClientInfoFailure = '[Auth] Fetch Client Info Failure',

  // Fetch Temp Token
  FetchTempToken = '[Auth] Fetch Temp Token',
  FetchTempTokenSuccess = '[Auth] Fetch Temp Token Success',
  FetchTempTokenFailure = '[Auth] Fetch Temp Token Failure',

  // Login SuccessFul
  LoginSuccessFul = '[Auth] Login Successful',

  // Generate OTP
  GenerateOTP = '[Auth] Generate OTP',
  GenerateOTPSuccess = '[Auth] Generate OTP Success',
  GenerateOTPFailure = '[Auth] Generate OTP Failure',

  // Verify OTP
  VerifyOTPAction = '[Auth] Verify OTP',
  VerifyOTPSuccess = '[Auth] Verify OTP Success',
  VerifyOTPFailure = '[Auth] Verify OTP Failure',

  Logout = '[Auth] Logout',

  //Recaptcha Verify
  VerifyRecaptchaToken = '[Auth] Verify Recaptcha Token',
  VerifyRecaptchaTokenSuccess = '[Auth] Verify Recaptcha Token Success',
  VerifyRecaptchaTokenFailure = '[Auth] Verify Recaptcha Token Failure',
}

// Client Info
export const FetchClientInfoAction = createAction(
  AuthActions.FetchClientInfo,
)
export const FetchClientInfoSuccessAction = createAction(
  AuthActions.FetchClientInfoSuccess,
  props<{ clientInfo: IClientInfo }>()
)
export const FetchClientInfoFailureAction = createAction(
  AuthActions.FetchClientInfoFailure,
  props<{ error: IErrors }>()
)

// Temp Token
export const FetchTempTokenAction = createAction(
  AuthActions.FetchTempToken,
  props<{ request: ITempTokenRequestBody, provider: 'apple' | 'google' }>()
);
export const FetchTempTokenSuccessAction = createAction(
  AuthActions.FetchTempTokenSuccess,
  props<{ response: ITempTokenResponse }>()
);
export const FetchTempTokenFailureAction = createAction(
  AuthActions.FetchTempTokenFailure,
  props<{ error: IErrors }>()
);

// Logout
export const LogoutAction = createAction(
  AuthActions.Logout,
  props<{ skipSessionLogout?: boolean }>()
);

// Login SucessFul
export const LoginSuccessFulAction = createAction(
  AuthActions.LoginSuccessFul,
  props<{ loginSuccessInfo: ILoginSuccessInfo }>()
)


// Generate OTP
export const GenerateOTPAction = createAction(
  AuthActions.GenerateOTP,
  props<{ request: IGenerateOTPRequestBody }>()
)
export const GenerateOTPSuccessAction = createAction(
  AuthActions.GenerateOTPSuccess,
  props<{ response: IGenerateOTPResponse }>()
)
export const GenerateOTPFailureAction = createAction(
  AuthActions.GenerateOTPFailure,
  props<{ error: IErrors }>()
)

// Verify OTP
export const VerifyOTPAction = createAction(
  AuthActions.VerifyOTPAction,
  props<{ request: IVerifyOTPRequestBody }>()
)
export const VerifyOTPSuccessAction = createAction(
  AuthActions.VerifyOTPSuccess,
  props<{ response: IVerifyOTPResponse }>()
);
export const VerifyOTPFailureAction = createAction(
  AuthActions.VerifyOTPFailure,
  props<{ error: IErrors }>()
);

// Verify Recaptcha Token
export const VerifyRecaptchaTokenAction = createAction(
  AuthActions.VerifyRecaptchaToken,
  props<{ request: IVerifyRecaptchaRequest }>()
);
// Verify Recaptcha Token Success
export const VerifyRecaptchaTokenSuccessAction = createAction(
  AuthActions.VerifyRecaptchaTokenSuccess,
  props<{ response: IResponse<IVerifyRecaptchaResponse> }>()
);
// Verify Recaptcha Token Failure
export const VerifyRecaptchaTokenFailureAction = createAction(
  AuthActions.VerifyRecaptchaTokenFailure,
  props<{ error: IErrors }>()
);